/* eslint-disable jsx-a11y/no-autofocus */
import { Box, Divider, SidePanel } from '@wix/design-system';
import React, { useContext } from 'react';

import { RicosContext } from './../../../ricos-context';
import { FocusManager, Panel, PanelHeader } from './../../../ui-components';

import { MODAL_ROOT } from '../data-hooks/data-hooks';
import { AttributesMobile } from './attributes/attributes-mobile';
import { Footer } from './footer';
import { SectionMobile } from './section/section-mobile';
import { TypeSelect } from './type-select';
import type { LinkModalProps } from './types';
import { useLinkModalState } from './use-link-modal-state';
import { WebAddress } from './web-address';

export const ModalMobile: React.FC<LinkModalProps> = ({
  initialValue,
  onClose,
  onSave,
  onUnlink,
}) => {
  const { jsdomMode, isMobile, t } = useContext(RicosContext);

  const {
    link,
    linkType,
    submitError,

    onChangeAttributes,
    onChangeWebAddress,
    onClickUnlink,
    onSelectSection,
    onSelectType,
    onSubmit,
    onValidateWebAddress,
  } = useLinkModalState({ initialValue, onClose, onSave, onUnlink });

  return (
    <FocusManager isMobile={isMobile} jsdomMode={jsdomMode}>
      <Panel
        dataHook={MODAL_ROOT}
        height="100%"
        onCloseButtonClick={onClose}
        skin="floating"
        width="100%"
      >
        <PanelHeader title={t('LinkSettings_Modal_Title')} />
        <SidePanel.Content noPadding>
          <Box boxSizing="border-box" direction="vertical" gap="SP3" height="100%" padding={0}>
            <Box padding="SP3" paddingBottom={0}>
              <TypeSelect
                autoFocus={false}
                onSelect={onSelectType}
                showSitePages={false}
                t={t}
                type={linkType}
              />
            </Box>
            {linkType === 'section' ? (
              <SectionMobile link={link} onSelect={onSelectSection} t={t} />
            ) : (
              <>
                <Box direction="vertical" paddingLeft="SP3" paddingRight="SP3">
                  <WebAddress
                    autoFocus
                    link={link}
                    onChangeUrl={onChangeWebAddress}
                    onValidateUrl={onValidateWebAddress}
                    submitError={submitError}
                    t={t}
                  />
                </Box>
                <Divider />
                <Box direction="vertical" padding="SP3">
                  <AttributesMobile link={link} onChange={onChangeAttributes} t={t} />
                </Box>
              </>
            )}
          </Box>
        </SidePanel.Content>
        <SidePanel.Footer showDivider>
          <Footer
            onClickCancel={onClose}
            onClickSave={onSubmit}
            onClickUnlink={onClickUnlink}
            showUnlink={!!initialValue}
            t={t}
          />
        </SidePanel.Footer>
      </Panel>
    </FocusManager>
  );
};
